module.exports = __webpack_public_path__ + "static/media/A11.3300744a.png";